import {Badge} from '@mantine/core';
import {StepStatus} from '../types.ts';

const colorByStatus: Record<StepStatus, string> = {
    [StepStatus.PENDING]: 'gray',
    [StepStatus.RUNNING]: 'blue',
    [StepStatus.SUCCEEDED]: 'green',
    [StepStatus.FAILED]: 'red',
    [StepStatus.SKIPPED]: 'yellow',
    [StepStatus.RETRYING]: 'orange',
};

export const StepStatusBadge = ({status}: { status?: StepStatus }) => {
    if (!status) {
        return <Badge color={'gray'} variant={'light'}>UNKNOWN</Badge>;
    }
    return (
        <Badge color={colorByStatus[status] ?? 'gray'} variant={'light'}>
            {status}
        </Badge>
    );
};
